<template>
  <div class="view">
    <h1 class="ui header">
      Error 404
      <div class="sub header">
        {{target || 'Object'}} <b>{{name ? ' "' + name + '"' : ''}}</b> is destroyed or never existed<span v-show="!member.isOwner">,<br>or you don't have permissions to see it</span>.
      </div>
    </h1>
    <br>
    <p>
      <router-link class="ui blue button" to="/">Go to Dashboard</router-link>
    </p>
  </div>
</template>

<script>
  import capitalize from 'lodash/capitalize'
  import {mapGetters} from 'vuex'

  export default {
    name: 'ErrorNotExist',
    computed: {
      ...mapGetters(['member']),
      target() {
        return capitalize(Object.keys(this.$route.query)[0])
      },
      name() {
        return Object.values(this.$route.query)[0]
      },
    }
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }
</style>
